'use strict';

var promisify = require('promisify-es6');

var transform = function transform(res, callback) {
  callback(null, {
    id: res.Id,
    name: res.Name
  });
};

module.exports = function (send) {
  return promisify(function (name, pem, password, callback) {
    send.andTransform({
      path: 'key/import',
      args: name,
      qs: {
        pem: pem,
        password: password
      }
    }, transform, callback);
  });
};